import { graphql } from '../../services/graphql'

const state = {
  suppliers: [],
  selectedSupplier: {
    id: null,
    name: ''
  }
}

const getters = {}

const actions = {
  getSuppliers(context) {
    const query = 'query getSupplier { suppliers {id name}}'
    graphql()
      .request(query)
      .then(data => context.commit('updateSuppliers', data.suppliers))
  }
}

const mutations = {
  updateSuppliers(state, payload) {
    state.suppliers = payload
  },
  setSelectedSupplier(state, supplier) {
    state.selectedSupplier = supplier
  },
  resetSelectedSupplier(state) {
    state.selectedSupplier = { id: null, name: '' }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/components/suppliers/suppliers.store.js